import '~styles/templates/single-post.scss';
import VendorScriptLoader from './utility/vendor-script-loader';
import { replaceImageWithFancybox } from './utility/fancybox-helper';

/**
 * Fancybox :: replaces all images in the post's content with a fancybox-ready version
 */
document.querySelectorAll('.blog-image').forEach(node => {
  replaceImageWithFancybox( node.querySelector('img') );
});

document.querySelectorAll('.wp-block-image').forEach(node => {
  replaceImageWithFancybox( node.querySelector('img') );
});

/**
 * Loads vendor
 */
document.addEventListener('vendor-fancybox:loaded', () => {
  import('~scripts/plugins/fancybox-plugin');
});

VendorScriptLoader.outputVendorScriptTag('vendor-fancybox');

